export function createProvideInjectKey<T_Any>(key: string): InjectionKey<T_Any> {
  if (import.meta.env.VITEST) {
    return key as unknown as InjectionKey<T_Any>;
  }
  return Symbol(key) as InjectionKey<T_Any>;
}
